import Cookies from 'js-cookie';

import getURLParameter from './getURLParameter';
import setLanguageCode from './setLanguageCode';


const CODE_NAME = 'lang';

/**
 * Read the language code from the cookie, possibly replacing it with the contents of a query string.
 */
export default function getLanguageCode() {
    const queryLang = getURLParameter(CODE_NAME);
    const cookieLang = Cookies.get(CODE_NAME);

    if (queryLang && cookieLang !== queryLang) {
        setLanguageCode(queryLang);
    }

    return Cookies.get(CODE_NAME);
}
